import { useState } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";
import { ICON_GROUPS, AppIcon } from "@/lib/appearanceIcons";

// Visual Lucide icon grid: search + grouping + selected state + "no icon" reset.
export function IconPicker({ value, onChange }) {
  const [q, setQ] = useState("");
  const query = q.trim().toLowerCase();
  return (
    <div className="space-y-2" data-testid="icon-picker">
      <div className="flex items-center gap-2">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search icons…" className="h-9" data-testid="icon-search" />
        <button type="button" onClick={() => onChange("")} data-testid="icon-none"
          className={cn("flex h-9 shrink-0 items-center gap-1 rounded-lg border px-2.5 text-xs font-medium transition-colors",
            !value ? "border-accent bg-accent-subtle text-accent" : "border-border text-muted-foreground hover:bg-muted")}>
          <X className="h-3.5 w-3.5" /> No icon
        </button>
      </div>
      <div className="max-h-52 space-y-3 overflow-y-auto scrollbar-thin pr-1">
        {ICON_GROUPS.map((g) => {
          const names = g.names.filter((n) => !query || n.toLowerCase().includes(query));
          if (!names.length) return null;
          return (
            <div key={g.label}>
              <div className="mb-1 px-0.5 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground/70">{g.label}</div>
              <div className="grid grid-cols-8 gap-1.5">
                {names.map((n) => (
                  <button key={n} type="button" onClick={() => onChange(n)} title={n} data-testid={`icon-opt-${n}`}
                    className={cn("flex aspect-square items-center justify-center rounded-lg border transition-colors",
                      value === n ? "border-accent bg-accent-subtle text-accent" : "border-border/60 text-muted-foreground hover:border-accent/60 hover:text-foreground")}>
                    <AppIcon name={n} className="h-4 w-4" />
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
